<template>

    <div>
        <!--<app-page-header></app-page-header>-->
        <v-container  grid-list-xl class="box">
            <v-form id="form_rfid_user" ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap align-center justify-center fill-height v-show="!loading">
                    <v-flex xs12 sm12 md10 lg5 xl4>
                        <v-card>

                            <v-card-text>
                                <div style="min-height: 10px;"></div>
                                <v-alert
                                    :color="(getCurrentSeason() == 'summer') ? getColor('summer') : getColor('winter_premium')"
                                    border="right"
                                    colored-border
                                    type="info"
                                    elevation="1"
                                >
                                    {{ translations.views.benefits.instructions }}
                                </v-alert>

                                <div v-if="isSummer">
                                    <img :src="cardHeaderSummer" width="100%" />
                                </div>
                                <div v-else>
                                    <img :src="cardHeaderWinter"  width="100%" />
                                </div>

                                <div style="text-align:center;margin-top:30px;">
                                    <h1>Kartica Julijske Alpe</h1>
                                    <br>
                                    <h3>{{ this.firstname + " " + this.lastname }}</h3>
                                    <h3>{{ this.card_restriction_start_date_formatted + " - " + this.card_restriction_end_date_formatted }}</h3>
                                    <h3>{{ "CardNr: " + this.id_code }}</h3>
                                </div>
                            </v-card-text>
                            
                            <div class="canvas-container" style="margin-top:-20px;">
                                <canvas ref="qrcodeCanvas"></canvas>
                            </div>
                            
                            <br>

                            <v-card-text>
                                <div v-if="isSummer">
                                <img :src="cardFooterSummer" width="100%" style="margin-bottom:-7px;" />
                                </div>
                                <div v-else>
                                    <img :src="cardFooterWinter" width="100%" style="margin-bottom:-7px;" />
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>

        <qr-code-dialog></qr-code-dialog>
    </div>

</template>

<script>
import { EventBus } from '@/main.js'
import qrCodeExample from '@/assets/example_qr_code.png'
const QrCodeDialog = () => import('@/components/QrCodeDialog.vue')
import qrCardExampleImg from '@/assets/qr_card_example.png'
import qrCardSummer from '@/assets/digital_card_summer.png'
import qrCardWinter from '@/assets/digital_card_winter.png'
import { formatDate, getCurrentDate, summerOrWinter } from '@/helpers/utilities.js'
import { HEX_SUMMER_BASIC, HEX_SUMMER, HEX_WINTER_PREMIUM, HEX_WINTER_BASIC } from '@/helpers/colors.js'
import QRCode from 'qrcode'

import card_summer_header from '@/assets/digital_card_bohinj_header_summer.png'
import card_summer_footer from '@/assets/digital_card_bohinj_footer_summer.png'

import card_winter_header from '@/assets/digital_card_bohinj_header_winter.png'
import card_winter_footer from '@/assets/digital_card_bohinj_footer_winter.png'


export default {

    components: {
        QrCodeDialog
    },
  
    data: () => ({
        card1: true,
        card2: true,
        card3: true,
        valid: true,
        loading: true,
        isSummer: true,

        user_account_registration_date_time: null,
        user_account_registration_date_time_formatted: null,
        firstname: null,
        lastname: null,

        card_id: null,
        card_number: "",
        card_valid: null,

        card_restriction_start_date: null,
        card_restriction_end_date: null,

        card_restriction_start_date_formatted: "",
        card_restriction_end_date_formatted: "",
        customer_id: null,
        id_code: null,
        id_number: null,
        from_date: null,
        to_date: null,
        status: null,
        valid_card: null,

        //inputData: "www.bohinj.si/qr?i="
        inputData: ""

    }),

    watch: {
        
    },  
    
    computed: {
        /*
        qrCardExample() {
            return qrCardExampleImg
        },
        */

        qrSize() {
            if(this.$vuetify.breakpoint.smAndDown) {
                return '100%';
            }

            return '60%'
        },

        siteLanguage() {
          return this.$store.getters.siteLanguage
        },

        translations() {
            let siteLanguage = this.$store.getters.siteLanguage

            return this.$store.getters.translations[siteLanguage]
        },

        cardHeaderSummer() {
            return card_summer_header
        },

        cardFooterSummer() {
            return card_summer_footer
        },

        cardHeaderWinter() {
            return card_winter_header
        },

        cardFooterWinter() {
            return card_winter_footer
        }
    },

    methods: {
        showQrCode() {
            let vm = this
            window.console.log("qr code ...")
            EventBus.$emit('QR_CODE_DIALOG', {
                qr_code_id: 1
            });
        },

        getCurrentSeason() {
            return summerOrWinter();
        },

        getColor(type) {
            if(type == "summer_basic") {
                return HEX_SUMMER_BASIC;
            }

            if(type == 'summer') {
                return HEX_SUMMER;
            }

            if(type == 'winter_basic') {
                return HEX_WINTER_BASIC
            }

            if(type == 'winter_premium') {
                return HEX_WINTER_PREMIUM
            }

            return ""
        },

        qrCardImg() {
            if(this.getCurrentSeason() == 'summer') {
                return qrCardSummer
            }

            return qrCardWinter
        },

        checkIfSummer() {
            let today = new Date();
            today.setHours(0,0,0,0);

            let currentYear = today.getFullYear();
            let currentMonth = today.getMonth();
            let currentDay = today.getDay();

            //window.console.log(currentYear + ", " + currentMonth + ", " + currentDay);

            const summerMonths = [3,4,5,6,7,8,9];

            if(summerMonths.includes(currentMonth)) {
                this.isSummer = true
                //this.isSummer = false
            } else {
                this.isSummer = false
                //this.isSummer = true
            }
        },

        accountInfo() {
            //window.console.log("account info...")
            this.$store.commit('SET_PROGRESS', true)
            this.$store.dispatch('USER_ACCOUNT_INFO')
            .then(response => {
                //window.console.log(response.data)

                this.user_account_registration_date_time = response.data.created_at
                this.user_account_registration_date_time_formatted = response.data.created_at_formatted
                this.firstname = response.data.name.split(" ")[0]
                this.lastname = response.data.name.split(" ")[1]
                
                this.card_number = response.data.card_number
                this.card_valid = response.data.card_valid
                //this.card_valid = null
                this.card_restriction_start_date = response.data.from_date
                this.card_restriction_end_date = response.data.to_date

                this.card_restriction_start_date_formatted = response.data.from_date_formatted
                this.card_restriction_end_date_formatted = response.data.to_date_formatted

                this.customer_id = response.data.customer_id
                this.id_code = response.data.id_code
                this.id_number = response.data.id_number
                this.from_date = response.data.from_date_formatted
                this.to_date = response.data.to_date_formatted 
                this.valid_card = response.data.valid
                this.card_valid = this.valid_card
                
                //this.inputData = this.inputData + response.data.id_number
                this.inputData = this.inputData + response.data.id_code

                this.generateQRCode()

            })
            .catch(err => {
                window.console.error(err)
            })
            .finally(() => {
                this.$store.commit('SET_PROGRESS', false)   
                this.loading = false
            })
        },

        generateQRCode() {
            const canvas = this.$refs.qrcodeCanvas;
            const size = canvas.parentElement.offsetWidth;
            QRCode.toCanvas(canvas, this.inputData, { width: size, height: size }, (error) => {
                if (error) console.error(error);
                //console.log('QR Code generated!');
            });
        },
        resizeQRCode() {
            if (this.inputData) {
                this.generateQRCode();
            }
        }
    },

    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 
        this.checkIfSummer();
        this.accountInfo();
    },

    mounted() {
        window.addEventListener('resize', this.resizeQRCode);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeQRCode);
    },

    destroyed() {

    }
}

</script>

<style scoped>
    .qr_code_img {
        margin-left:auto;
        margin-right:auto;
        margin-top: 30px;
        margin-bottom: 20px;
    }

    .canvas-container {
        width: 100%;
        height: auto;
        max-width: 300px; /* You can set a maximum width if needed */
        margin: auto;
        display: flex;
        justify-content: center;
    }
    canvas {
        /*width: 95% !important;*/
        width: 60% !important;
        height: auto !important;
    }
</style>